const secrets = {
  serverUrl: 'https://caebes.com:6567',
  // serverUrl: 'http://localhost:1337',
  MAPSAPIKEY: 'AIzaSyAvcOTqJyMau74OQdBHz4puiG9rkVLM8VU',
};

export default secrets;
